import { createParser, system } from "../core";
import { t } from "../utils";
var config = {
  listStyleType: true,
  listStylePosition: true,
  listStylePos: t.prop("listStylePosition"),
  listStyleImage: true,
  listStyleImg: t.prop("listStyleImage")
};
export var list = system(config);
export var listParser = createParser(config);
//# sourceMappingURL=list.js.map